export const extractText = (htmlString: string): string => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;
  const textContent = tempDiv.textContent || tempDiv.innerText;
  return textContent.trimStart();
}
